import type { DicomSyntaxConfig } from '../types/dicom';

// Default syntax configuration
export const defaultSyntaxConfig: DicomSyntaxConfig = {
  secondaryCaptureImageStorage: {
    explicitVrBigEndian: 'rejected',
    explicitVrLittleEndian: 'rejected',
    implicitVrLittleEndian: 'rejected',
    jpeg2000ImageCompression: 'rejected',
    jpeg2000ImageCompressionLosslessOnly: 'rejected',
    jpegBaselineProcess1: 'rejected',
    jpegLosslessNonHierarchicalFirstOrderPredictionProcess14SelectionValue1:
      'rejected',
    jpegLsLosslessImageCompression: 'rejected',
    jpegLsLossyNearLosslessImageCompression: 'rejected',
  },
  ultrasoundImageStorage: {
    explicitVrBigEndian: 'accepted',
    explicitVrLittleEndian: 'accepted',
    implicitVrLittleEndian: 'accepted',
    jpeg2000ImageCompression: 'accepted',
    jpeg2000ImageCompressionLosslessOnly: 'accepted',
    jpegBaselineProcess1: 'accepted',
    jpegLosslessNonHierarchicalFirstOrderPredictionProcess14SelectionValue1:
      'accepted',
    jpegLsLosslessImageCompression: 'rejected',
    jpegLsLossyNearLosslessImageCompression: 'rejected',
  },
  ultrasoundMultiFrameImageStorage: {
    explicitVrBigEndian: 'accepted',
    explicitVrLittleEndian: 'accepted',
    implicitVrLittleEndian: 'accepted',
    jpeg2000ImageCompression: 'accepted',
    jpeg2000ImageCompressionLosslessOnly: 'accepted',
    jpegBaselineProcess1: 'accepted',
    jpegLosslessNonHierarchicalFirstOrderPredictionProcess14SelectionValue1:
      'accepted',
    jpegLsLosslessImageCompression: 'rejected',
    jpegLsLossyNearLosslessImageCompression: 'rejected',
  },
  verificationSopClass: {
    explicitVrBigEndian: 'rejected',
    explicitVrLittleEndian: 'rejected',
    implicitVrLittleEndian: 'accepted',
  },
};

// Abstract Syntax metadata
export const abstractSyntaxInfo = {
  secondaryCaptureImageStorage: {
    name: 'Secondary Capture Image Storage',
    sopClassUid: '1.2.840.10008.5.1.4.1.1.7',
    description:
      'Storage of secondary capture images (screenshots, derived images)',
  },
  ultrasoundImageStorage: {
    name: 'Ultrasound Image Storage',
    sopClassUid: '1.2.840.10008.5.1.4.1.1.6.1',
    description: 'Storage of ultrasound images',
  },
  ultrasoundMultiFrameImageStorage: {
    name: 'Ultrasound Multi-frame Image Storage',
    sopClassUid: '1.2.840.10008.5.1.4.1.1.3.1',
    description: 'Storage of multi-frame ultrasound images',
  },
  verificationSopClass: {
    name: 'Verification SOP Class',
    sopClassUid: '1.2.840.10008.1.1',
    description: 'DICOM verification and echo services',
  },
};

// Transfer Syntax metadata
export const transferSyntaxInfo = {
  explicitVrBigEndian: {
    name: 'Explicit VR Big Endian',
    uid: '1.2.840.10008.1.2.2',
    type: 'Uncompressed',
  },
  explicitVrLittleEndian: {
    name: 'Explicit VR Little Endian',
    uid: '1.2.840.10008.1.2.1',
    type: 'Uncompressed',
  },
  implicitVrLittleEndian: {
    name: 'Implicit VR Little Endian',
    uid: '1.2.840.10008.1.2',
    type: 'Uncompressed',
  },
  jpeg2000ImageCompression: {
    name: 'JPEG 2000 Image Compression',
    uid: '1.2.840.10008.1.2.4.91',
    type: 'Compressed',
  },
  jpeg2000ImageCompressionLosslessOnly: {
    name: 'JPEG 2000 Part 1 Lossless Only',
    uid: '1.2.840.10008.1.2.4.90',
    type: 'Compressed',
  },
  jpegBaselineProcess1: {
    name: 'JPEG Baseline Process 1',
    uid: '1.2.840.10008.1.2.4.50',
    type: 'Compressed',
  },
  jpegLosslessNonHierarchicalFirstOrderPredictionProcess14SelectionValue1: {
    name: 'JPEG Lossless, Non-Hierarchical',
    uid: '1.2.840.10008.1.2.4.70',
    type: 'Compressed',
  },
  jpegLsLosslessImageCompression: {
    name: 'JPEG-LS Lossless Image Compression',
    uid: '1.2.840.10008.1.2.4.80',
    type: 'Compressed',
  },
  jpegLsLossyNearLosslessImageCompression: {
    name: 'JPEG-LS Lossy (Near-Lossless)',
    uid: '1.2.840.10008.1.2.4.81',
    type: 'Compressed',
  },
};
